import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import '../app.css'
import App from '../App.vue'
import sportRoutes from '../router/routes/sport'
import { initSentry } from '../lib/sentry'

// Branding
document.title = 'Sport | Codifyo'
const faviconLink = document.getElementById('favicon-link')
if (faviconLink) {
    faviconLink.setAttribute('href', '/favicon-sport.png')
}

const router = createRouter({
    history: createWebHistory(),
    routes: sportRoutes,
})

const app = createApp(App)
app.use(router)
initSentry(app, router)
app.mount('#app')
